import { render, staticRenderFns } from "./PromoImage.vue?vue&type=template&id=6c9c26f5&scoped=true&"
import script from "./PromoImage.vue?vue&type=script&lang=js&"
export * from "./PromoImage.vue?vue&type=script&lang=js&"
import style0 from "./PromoImage.vue?vue&type=style&index=0&id=6c9c26f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9c26f5",
  null
  
)

export default component.exports